import apiClient from "../api/apiClient";

type ResponseDto<T> = {
  loggingHistoryID?: number;
  statusCode: number;
  isSuccess: boolean;
  message: string;
  errors?: string[];
  data?: T;
  dataList?: T[];
};

export const publicService = {
    Getproductdetails: async (slug: string): Promise<ResponseDto<any>> => {
        const response = await apiClient.get<ResponseDto<any>>(`/Public/Getproductdetails/${slug}`);
        return response.data;
      },
      addReview: async (data: any): Promise<ResponseDto<any>> => {
        const response = await apiClient.post<ResponseDto<any>>(`/Public/AddReview`, data);
        return response.data;
      }
}